import { Alert, Collapse, Divider, Segmented, Space, Affix, Tooltip } from "antd";
import React, { useState } from "react";
import { Container, Draggable } from "react-smooth-dnd";
import { components_data } from "../data";
import ComponentLabel, { getComponent } from "./Components/Components";
import { tt_global_banner } from "../utils/Utils";

export default function ContentPanel(props) {

    const { globalTarget = false, setGlobalTarget = () => { } } = props;
    const { groups = [], components = [] } = components_data;

    const onDrop = (e) => {

    }

    const getPayload = (_group, _index) => {

        let arr = components.filter(component => component.group === _group)
        console.log(arr);
        return arr[_index];

        return components.filter(component => component.group === _group)[_index];
    }

    const drawComponents = (_group) => {
        return components.filter(component => component.group === _group).map(component => {
            const { key = "", label = "", group = "", icon = "" } = component;
            return (
                <Draggable group={group} key={key}>
                    <div className="component-label">
                        <Space align="center">
                            {(icon && <><img src={"/create/icons/" + icon} /></>)}
                            <div>{label}</div>
                        </Space>
                    </div>
                </Draggable>
            )
        })
    }

    const drawPanels = () => {
        return groups.map(group => {
            const { key = "", label = "" } = group;
            return (
                <Collapse.Panel key={key} header={<strong>{label}</strong>}>

                    {(group.description && <>
                        <Alert style={{ "padding": "8px 10px" }} description={<small>{group.description}</small>} />
                        <div className="shim" /><div className="shim" />
                    </>)}
                    <Container getChildPayload={(_index) => {
                        return getPayload(key, _index)
                    }} groupName="1" behaviour="copy" onDrop={(e) => onDrop(e)}>


                        {drawComponents(key)}
                    </Container>
                </Collapse.Panel>
            )
        })
    }


    const [showHelp, setShopHelp] = useState(true)

    return (
        <>
            {(showHelp &&
                <>
                    <div style={{ "position": "fixed", "zIndex": "11", "backgroundColor": "#fafafa", "width": "300px", "marginTop": "-10px" }}>
                        <div style={{ "padding": "5px 10px", "backgroundColor": "#fafafa", "borderBottom": "1px solid #d9d9d9" }}>
                            <Alert style={{"lineHeight" : "10px"}} onClose={() => setShopHelp(false)} closable description={<div style={{"lineHeight" : "14px"}}><small> Drag and drop a component onto the page where you want it placed, then use the <strong>Edit</strong> button to make changes.</small></div>} />
                            <div className="shim" />
                        </div>
                    </div>
                    <div style={{ "height": "95px" }}></div>
                </>

            )}



            <div style={{ "padding": "0px 15px" }}>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DROP TARGET</Divider>
                <Segmented className={(globalTarget) ? "toggle-bg-global" : "toggle-bg-local"} value={globalTarget} onChange={(e) => setGlobalTarget(e)} style={{ "fontSize": "11px", "width": "270px" }} block options={
                    [
                        {
                            label: "Selected Page",
                            value: false
                        }, {
                            label: <Tooltip title={tt_global_banner}>Global Banner</Tooltip>,
                            value: true
                        }
                    ]
                } />
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">COMPONENTS</Divider>

            </div>


            <Collapse accordion onKeyDown={(e) => { }} style={{ border: "none", width: "300px" }}>
                {drawPanels()}
            </Collapse>

        </>
    )
}